import { render, staticRenderFns } from "./PatientRow.vue?vue&type=template&id=52eb661a&scoped=true"
import script from "./PatientRow.vue?vue&type=script&lang=ts"
export * from "./PatientRow.vue?vue&type=script&lang=ts"
import style0 from "./PatientRow.vue?vue&type=style&index=0&id=52eb661a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eb661a",
  null
  
)

export default component.exports